import ReturnConfirmationLabelSection from 'components/account/Returns/ReturnConfirmationLabelSection';
import ReturnsAndExchanges from 'components/account/ReturnsAndExchanges';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';

const ReturnConfirmationInstruction = ({
  showReturnInstructionsBoxes,
  labelDelivery,
  customerInfo,
  boxInfo,
  postReturnInfo,
  UPSPickUpAddress,
  showLabellessReturns,
  showPackagelessReturn
}) => {
  if (showReturnInstructionsBoxes) {
    return (
      <ReturnConfirmationLabelSection
        labelDelivery={labelDelivery}
        customerInfo={customerInfo}
        boxInfo={boxInfo}
        postReturnInfo={postReturnInfo}
        showLabellessReturns={showLabellessReturns}
        UPSPickUpAddress={UPSPickUpAddress}
        showPackagelessReturn={showPackagelessReturn}
      />
    );
  }

  if (labelDelivery !== PROVIDE_LABEL_OPTIONS.PICKUP) {
    return <ReturnsAndExchanges labelDelivery={labelDelivery} />;
  }

  return <ReturnsAndExchanges labelDelivery={labelDelivery} UPSPickUpAddress={UPSPickUpAddress} displayUPSPickUpAddress={true} />;
};

export default ReturnConfirmationInstruction;
